module.exports = __webpack_public_path__ + "static/media/background.a3e84e80.jpg";